import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { listDevices, formatIct, POLL_INTERVAL_MS } from "./imdRemoteApi";

// เมนู "ควบคุมเครื่อง IMD" (ผู้ดูแลเท่านั้น) — ตารางเครื่องทั้งหมด
// กฎ: ซ่อนรหัสระบบ (deviceId) โชว์ชื่อสาย/เครื่อง · ชื่อเป็นลิงก์ไปหน้าเครื่อง
export default function ImdRemoteControl({ pollMs = POLL_INTERVAL_MS }) {
    const [devices, setDevices] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState("");

    const load = useCallback(async () => {
        try {
            setDevices(await listDevices());
            setError("");
        } catch (e) {
            setError(e.message || "โหลดไม่สำเร็จ");
        } finally {
            setLoaded(true);
        }
    }, []);

    // poll ขณะเปิดหน้า (contract: 5 วิ)
    useEffect(() => {
        load();
        const timer = setInterval(load, pollMs);
        return () => clearInterval(timer);
    }, [load, pollMs]);

    return (
        <div style={{ maxWidth: "1100px" }}>
            <h3>ควบคุมเครื่อง IMD</h3>
            <p style={{ color: "#666", fontSize: "13px" }}>
                ส่งคำสั่งไปเครื่องได้ทีละเครื่อง · เครื่องที่ออฟไลน์จะรับคำสั่งเมื่อกลับมา (ภายใน 10 นาที) · รายการอัปเดตเองทุก 5 วินาที
            </p>

            {error && <div style={{ color: "#c00", marginBottom: "10px" }}>⚠️ {error}</div>}

            {loaded && devices.length === 0 && !error && (
                <div style={{ color: "#666" }}>ยังไม่มีเครื่องที่เคยเชื่อมต่อ</div>
            )}

            {devices.length > 0 && (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                    <thead>
                        <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                            <th style={th}>ชื่อสาย / เครื่อง</th>
                            <th style={th}>รุ่นแอพ</th>
                            <th style={th}>สถานะ</th>
                            <th style={th}>เห็นล่าสุด (ICT)</th>
                            <th style={th}>รอบปัจจุบัน</th>
                            <th style={th}>งานค้าง</th>
                        </tr>
                    </thead>
                    <tbody>
                        {devices.map((d) => (
                            <tr key={d.deviceId} style={{ borderBottom: "1px solid #eee" }}>
                                <td style={td}>
                                    <Link to={`/ImdRemoteControl/${encodeURIComponent(d.deviceId)}`} style={{ fontWeight: "bold" }}>
                                        {d.label || "ยังไม่ตั้งชื่อ"}
                                    </Link>
                                </td>
                                <td style={td}>vc {d.appVersionCode}</td>
                                <td style={td}>
                                    <span style={d.online ? badgeOnline : badgeOffline}>{d.online ? "ออนไลน์" : "ออฟไลน์"}</span>
                                </td>
                                <td style={td}>{formatIct(d.lastSeenAt)}</td>
                                <td style={td}>
                                    {d.activeRound
                                        ? `${d.activeRound.started ? "เริ่มแล้ว" : "ยังไม่เริ่ม"}${d.activeRound.driverName ? ` · ${d.activeRound.driverName}` : ""}`
                                        : "—"}
                                </td>
                                <td style={td}>{d.outboxCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

const th = { padding: "8px", borderBottom: "1px solid #ddd" };
const td = { padding: "8px", verticalAlign: "middle" };
const badgeBase = { padding: "2px 8px", borderRadius: "10px", fontSize: "12px", color: "white" };
const badgeOnline = { ...badgeBase, background: "#2e7d32" };
const badgeOffline = { ...badgeBase, background: "#9e9e9e" };
